import { useInjection } from '@cp/shared/di';
import { SELECTION_SERVICE } from '../di';

export const useClientSelectionService = () => useInjection(SELECTION_SERVICE);
